import { motion } from "framer-motion";
import { FaGithub } from "react-icons/fa";
import { FaMediumM } from "react-icons/fa";
import Typewriter from "typewriter-effect";
import { FaLinkedinIn } from "react-icons/fa";

const iconVariants = {
  hover: { scale: 1.2 },
  tap: { scale: 0.8 },
};

function Profile({ phone, email, location }) {
  return (
    <>
      <div className="xl:flex flex-col justify-center text-center hidden">
        <div className="flex flex-col justify-center custom-card mt-5 mx-10 mb-4">
          <img
            className="max-h-52 max-w-40 mx-auto my-3"
            alt="Sharan Sukesh"
            src="./assets/images/face.png"
          />
        </div>
        <p className="text-2xl text-white font-bold font-[poppins]">
          Sharan Sukesh
        </p>
        <div className="font-[poppins] mx-auto mt-5 text-white mb-3 custom-card px-3 py-1.5 ">
          <Typewriter
            options={{
              cursor: "",
            }}
            onInit={(typewriter) => {
              typewriter.typeString("Software Developer").start();
            }}
          />
        </div>
        <div className="divider before:bg-purple-500 after:bg-purple-500"></div>
        {email}
        {phone}
        {location}
        <div className="flex flex-row justify-around px-3 py-5">
          <a href="https://www.linkedin.com/in/sharan-sukesh-0a0b77157/">
            <motion.div
              variants={iconVariants}
              whileHover="hover"
              whileTap="tap"
            >
              <FaLinkedinIn size={25} color="white" />
            </motion.div>
          </a>
          <a href="https://github.com/sharansukesh1003">
            <motion.div
              variants={iconVariants}
              whileHover="hover"
              whileTap="tap"
            >
              <FaGithub size={25} color="white" />
            </motion.div>
          </a>
          <a href="https://medium.com/@sharansukesh2000">
            <motion.div
              variants={iconVariants}
              whileHover="hover"
              whileTap="tap"
            >
              <FaMediumM size={25} color="white" />
            </motion.div>
          </a>
        </div>
      </div>
      <div className="flex flex-col xl:hidden">
        <div className="flex-row gap-6 justify-start text-center flex mx-5 my-3">
          <img
            alt="Sharan Sukesh"
            src="./assets/images/face.png"
            className="custom-card max-h-24 max-w-16 p-1"
          />
          <div className="flex flex-col text-start align-middle justify-center gap-3">
            <p className="text-xl text-white font-bold font-[poppins]">
              Sharan Sukesh
            </p>
            <div className="w-min whitespace-nowrap font-[poppins] text-sm h-min text-white custom-card px-3 py-1.5 ">
              <Typewriter
                options={{
                  cursor: "",
                }}
                onInit={(typewriter) => {
                  typewriter.typeString("Software Developer").start();
                }}
              />
            </div>
          </div>
        </div>
        <div className="divider before:bg-purple-500 after:bg-purple-500 mx-5" />
        <div className="grid sm:grid-cols-2 ml-2">
          {email}
          {phone}
          {location}
        </div>
        <div className="divider before:bg-purple-500 after:bg-purple-500 mx-5" />
        <div className="flex flex-row justify-start gap-5 m-5">
          <a href="https://www.linkedin.com/in/sharan-sukesh-0a0b77157/">
            <FaLinkedinIn size={25} color="white" />
          </a>
          <a href="https://github.com/sharansukesh1003">
            <FaGithub size={25} color="white" />
          </a>
          <a href="https://medium.com/@sharansukesh2000">
            <FaMediumM size={25} color="white" />
          </a>
        </div>
      </div>
    </>
  );
}

export default Profile;
